// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import articles from "./ArticlesBulk";
// import AdSenseAd from "../JobDetails/AdsenseAd";

// const ArticleDetail = () => {
//   const { id } = useParams();
//   const article = articles.find((a) => a.id === parseInt(id));

//   const [content, setContent] = useState("");
//   const [started, setStarted] = useState(false);
//   const [timeLeft, setTimeLeft] = useState(15);
//   const [finished, setFinished] = useState(false);

//   // 🔥 Countdown logic
//   useEffect(() => {
//     if (!started) return;

//     if (timeLeft === 0) {
//       setFinished(true);
//       return;
//     }

//     const timer = setTimeout(() => {
//       setTimeLeft((prev) => prev - 1);
//     }, 1000);

//     return () => clearTimeout(timer);
//   }, [started, timeLeft]);

//   // 🔥 Load file content
//   useEffect(() => {
//     if (article?.file) {
//       fetch(article.file)
//         .then((res) => res.text())
//         .then((data) => setContent(data));
//     }
//   }, [article]);

//   if (!article)
//     return <p className="text-center mt-10">Article not found.</p>;

//   return (
//     <div className="max-w-4xl mx-auto py-6 px-4">

//       {/* 🔥 TOP CONTINUE BUTTON */}
//       <div className="flex justify-center mb-4">
//         <button
//           onClick={() => setStarted(true)}
//           disabled={started}
//           className={`px-5 py-2 rounded ${started
//             ? "bg-gray-400 text-white cursor-not-allowed"
//             : "bg-blue-600 text-white"
//             }`}
//         >
//           Continue
//         </button>
//       </div>

//       {/* 💰 TOP AD */}
//       <div className="my-6">
//         <AdSenseAd
//           client="ca-pub-2161842895850825"
//           slot="2033357033"
//           format="auto"
//           responsive="true"
//         />
//       </div>

//       {/* 🔥 ARTICLE TITLE */}
//       <h1 className="text-2xl font-bold mb-4">{article.title}</h1>
//       <p className="text-gray-700 mb-4">{article.description}</p>

//       {/* 🔥 FILE CONTENT */}
//       {article.file ? (
//         <div className="prose max-w-none text-gray-700">
//           {content.split("\n").map((line, idx) =>
//             line.trim() ? <p key={idx}>{line}</p> : <br key={idx} />
//           )}
//         </div>
//       ) : (
//         <div className="space-y-6">

//           {[...Array(10)].map((_, index) => {
//             const subtopicKey = `subtopic${index + 1}`;
//             const descriptionKey = `description${index + 1}`;

//             if (article[subtopicKey] || article[descriptionKey]) {
//               return (
//                 <div key={index}>

//                   {/* 🔥 TIMER IN MIDDLE (ONLY ONCE) */}
//                   {index === 2 && (
//                     <div className="text-center my-6 bg-gray-100 p-4 rounded-lg">
//                       {!started && (
//                         <p className="text-gray-500">
//                           Click Continue to start timer
//                         </p>
//                       )}

//                       {started && !finished && (
//                         <p className="text-gray-700 text-lg">
//                           Please wait{" "}
//                           <span className="text-blue-600 font-bold text-3xl">
//                             {timeLeft}
//                           </span>{" "}
//                           seconds
//                         </p>
//                       )}

//                       {finished && (
//                         <p className="text-green-600 font-semibold text-lg">
//                           Link Ready ✅
//                         </p>
//                       )}
//                     </div>
//                   )}

//                   {/* 🔥 CONTENT */}
//                   {article[subtopicKey] && (
//                     <h2 className="text-lg font-semibold text-indigo-600">
//                       {article[subtopicKey]}
//                     </h2>
//                   )}

//                   {article[descriptionKey] && (
//                     <p className="text-gray-600">
//                       {article[descriptionKey]}
//                     </p>
//                   )}

//                   {/* 💰 MID AD */}
//                   <div className="my-4">
//                     <AdSenseAd
//                       client="ca-pub-2161842895850825"
//                       slot="2033357033"
//                       format="auto"
//                       responsive="true"
//                     />
//                   </div>
//                 </div>
//               );
//             }

//             return null;
//           })}

//           {/* 🔥 iframe (if exists) */}
//           {/* {article.iframeUrl && (
//             <div className="relative w-full pt-[56.25%] mt-6">
//               <iframe
//                 className="absolute top-0 left-0 w-full h-full"
//                 src={article.iframeUrl}
//                 title={article.title}
//                 allowFullScreen
//               ></iframe>
//             </div>
//           )} */}
//         </div>
//       )}
//       <iframe
//         src="https://docs.google.com/forms/d/e/1FAIpQLSfPu-WWr7_AGba5GUHIc-nBEUfysuyJRmXPmQ3PYnBfJru5ZQ/viewform?embedded=true"
//         className="w-full h-[700px]"
//         title="User Feedback Form"
//         frameBorder="0"
//         loading="lazy"
//       >
//       </iframe>

//       {/* 🔥 BOTTOM BUTTON */}
//       <div className="text-center mt-10">
//         <button
//           disabled={!finished}
//           onClick={() =>
//             window.open(article.iframeUrl || "#", "_blank")
//           }
//           className={`w-full py-4 text-lg font-semibold rounded ${finished
//             ? "bg-blue-600 text-white"
//             : "bg-gray-400 text-white cursor-not-allowed"
//             }`}
//         >
//           Go to Next Page
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ArticleDetail;


// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import articles from "./ArticlesBulk";
// import AdManagerAd from "../JobDetails/AdsenseAd";

// const ArticleDetail = () => {
//   const { id } = useParams();
//   const article = articles.find((a) => a.id === parseInt(id));
//   const [content, setContent] = useState("");

//   // ✅ Responsive size mapping
//   const sizeMapping = [
//     { viewport: [1024, 0], sizes: [[970, 90], [728, 90]] },
//     { viewport: [768, 0], sizes: [[468, 60]] },
//     { viewport: [0, 0], sizes: [[300, 250], [320, 50]] },
//   ];

//   // ✅ Optimized fetch
//   useEffect(() => {
//     if (!article?.file) return;

//     fetch(article.file)
//       .then((res) => res.text())
//       .then((data) => setContent(data));
//   }, [article?.file]);

//   if (!article)
//     return <p className="text-center mt-10">Article not found.</p>;

//   return (
//     <div className="max-w-4xl mx-auto py-10 px-5">
//       <h1 className="text-3xl font-bold mb-5">{article.title}</h1>
//       <p className="text-gray-700 mb-5">{article.description}</p>

//       {article.file ? (
//         <div className="prose max-w-none text-gray-700">
//           {content.split("\n").map((line, idx) =>
//             line.trim() ? <p key={idx}>{line}</p> : <br key={idx} />
//           )}
//         </div>
//       ) : (
//         <div className="border-t border-gray-200 pt-5 space-y-6">
//           {[...Array(10)].map((_, index) => {
//             const subtopicKey = `subtopic${index + 1}`;
//             const descriptionKey = `description${index + 1}`;

//             if (article[subtopicKey] || article[descriptionKey]) {
//               return (
//                 <div key={index}>
//                   {article[subtopicKey] && (
//                     <h2 className="text-lg font-medium text-indigo-600">
//                       {article[subtopicKey]}
//                     </h2>
//                   )}

//                   {article[descriptionKey] && (
//                     <p className="text-gray-600 mt-1">
//                       {article[descriptionKey]}
//                     </p>
//                   )}

//                     {(index + 1) % 3 === 0 && (
//               <div className="col-span-full my-6 flex justify-center w-full overflow-hidden min-h-[100px]">
//                 <AdManagerAd
//                   adUnit="/23318400632/Display/inline"
//                   size={[
//                     [970, 90],
//                     [728, 90],
//                     [468, 60],
//                     [300, 250],
//                     [320, 50],
//                   ]}
//                   sizeMapping={sizeMapping}
//                   divId={`div-gpt-ad-inline-${index}`}
//                 />
//               </div>
//             )}
//                 </div>
//               );
//             }
//             return null;
//           })}
//         </div>
//       )}

//       {/* ❌ REMOVE THIS (use only ONE sticky in Footer) */}
//       {/*
//       <div className="fixed bottom-0 left-0 w-full flex justify-center z-50 bg-white">
//         <AdManagerAd
//           adUnit="/23318400632/Display/sticky"
//           size={[300, 50]}
//           divId="div-gpt-ad-sticky-detail"
//         />
//       </div>
//       */}
//     </div>
//   );
// };

// export default ArticleDetail;



// original file
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import articles from "./ArticlesBulk";
// import AdManagerAd from "../JobDetails/AdsenseAd";

// const ArticleDetail = () => {
//   const { id } = useParams();
//   const article = articles.find((a) => a.id === parseInt(id));
//   const [content, setContent] = useState("");
//   const [showSticky, setShowSticky] = useState(true);

//   // ✅ Ad Units
//   const adUnits = {
//     top: "/23318400632/Display/top",
//     inline: "/23318400632/Display/inline",
//     inlineAlt: "/23318400632/displau", // your new ID
//     sticky: "/23318400632/sticky2",
//   };

//   // ✅ Responsive sizes
//   const sizeMapping = [
//     { viewport: [1024, 0], sizes: [[970, 90], [728, 90]] },
//     { viewport: [768, 0], sizes: [[468, 60]] },
//     { viewport: [0, 0], sizes: [[300, 250], [320, 50]] },
//   ];

//   // ✅ Fetch article content
//   useEffect(() => {
//     if (!article?.file) return;

//     fetch(article.file)
//       .then((res) => res.text())
//       .then((data) => setContent(data));
//   }, [article?.file]);

//   // 🔥 AUTO REFRESH ADS (every 30 sec)
//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (window.googletag && window.googletag.pubads) {
//         try {
//           window.googletag.pubads().refresh();
//           console.log("Ads refreshed");
//         } catch (e) {
//           console.log("Refresh error", e);
//         }
//       }
//     }, 30000); // 30 seconds

//     return () => clearInterval(interval);
//   }, []);

//   if (!article) {
//     return <p className="text-center mt-10">Article not found.</p>;
//   }

//   return (
//     <div className="max-w-4xl mx-auto py-10 px-5 pb-24">

//       {/* ✅ Title */}
//       <h1 className="text-3xl font-bold mb-5">{article.title}</h1>
//       <p className="text-gray-700 mb-5">{article.description}</p>

//       {/* 🔝 TOP AD */}
//       <div className="my-6 flex justify-center">
//         <AdManagerAd
//           adUnit={adUnits.top}
//           size={[[970, 90], [728, 90], [320, 50]]}
//           sizeMapping={sizeMapping}
//           divId="div-gpt-ad-top"
//         />
//       </div>

//       {/* ✅ FILE CONTENT */}
//       {article.file ? (
//         <div className="prose max-w-none text-gray-700">
//           {content.split("\n").map((line, idx) =>
//             line.trim() ? <p key={idx}>{line}</p> : <br key={idx} />
//           )}
//         </div>
//       ) : (
//         <div className="border-t border-gray-200 pt-5 space-y-6">
//           {[...Array(10)].map((_, index) => {
//             const subtopicKey = `subtopic${index + 1}`;
//             const descriptionKey = `description${index + 1}`;

//             if (article[subtopicKey] || article[descriptionKey]) {
//               return (
//                 <React.Fragment key={index}>

//                   {/* 📄 CONTENT */}
//                   <div>
//                     {article[subtopicKey] && (
//                       <h2 className="text-lg font-medium text-indigo-600">
//                         {article[subtopicKey]}
//                       </h2>
//                     )}
//                     {article[descriptionKey] && (
//                       <p className="text-gray-600 mt-1">
//                         {article[descriptionKey]}
//                       </p>
//                     )}
//                   </div>

//                   {/* 🔥 INLINE ADS (every 2 sections) */}
//                   {(index + 1) % 2 === 0 && (
//                     <div className="my-6 flex justify-center min-h-[100px]">
//                       <AdManagerAd
//                         adUnit={
//                           index % 4 === 0
//                             ? adUnits.inline
//                             : adUnits.inlineAlt
//                         }
//                         size={[
//                           [970, 90],
//                           [728, 90],
//                           [468, 60],
//                           [300, 250],
//                           [320, 50],
//                         ]}
//                         sizeMapping={sizeMapping}
//                         divId={`div-gpt-ad-inline-${index}`}
//                       />
//                     </div>
//                   )}

//                 </React.Fragment>
//               );
//             }

//             return null;
//           })}
//         </div>
//       )}

//       {/* 📌 STICKY AD */}
//       {showSticky && (
//         <div className="fixed bottom-0 left-0 w-full flex justify-center z-50 bg-white shadow-md">

//           {/* ❌ Close Button */}
//           <button
//             onClick={() => setShowSticky(false)}
//             className="absolute right-2 top-1 text-black text-lg"
//           >
//             ✕
//           </button>

//           <AdManagerAd
//             adUnit={adUnits.sticky}
//             size={[[728, 90], [320, 50]]}
//             sizeMapping={sizeMapping}
//             divId="div-gpt-ad-sticky"
//           />
//         </div>
//       )}

//     </div>
//   );
// };

// export default ArticleDetail;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import articles from "./ArticlesBulk";
import AdManagerAd from "../JobDetails/AdsenseAd";

const ArticleDetail = () => {
  const { id } = useParams();
  const article = articles.find((a) => a.id === parseInt(id));

  const [content, setContent] = useState("");
  const [showSticky, setShowSticky] = useState(true);

  // ✅ Ad Units
  const adUnits = {
    top: "/23318400632/Display/top",
    inline: "/23318400632/Display/inline",
    inlineAlt: "/23318400632/display",
    sticky: "/23318400632/sticky2",
  };

  // ✅ Responsive Size Mapping
  const sizeMapping = [
    { viewport: [1024, 0], sizes: [[970, 50]] },
    { viewport: [0, 0], sizes: [[300, 250]] },
  ];

  // ✅ Fetch Article Content
  useEffect(() => {
    if (!article?.file) return;

    fetch(article.file)
      .then((res) => res.text())
      .then((data) => setContent(data))
      .catch((err) => console.log(err));
  }, [article?.file]);

  // 🔥 Auto Refresh Ads Every 30 Seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.googletag && window.googletag.pubads) {
        try {
          window.googletag.pubads().refresh();
          console.log("Ads refreshed");
        } catch (e) {
          console.log("Refresh error", e);
        }
      }
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  // ❌ Article Not Found
  if (!article) {
    return (
      <p className="text-center mt-10 text-red-500">
        Article not found.
      </p>
    );
  }

  return (
    <div className="max-w-4xl mx-auto py-10 px-5 pb-24">

      {/* ✅ Article Title */}
      <h1 className="text-3xl font-bold mb-4">
        {article.title}
      </h1>

      {/* ✅ Description */}
      <p className="text-gray-700 mb-6">
        {article.description}
      </p>

      {/* 🔝 TOP AD */}
      <div className="my-6 flex justify-center">
        <AdManagerAd
          adUnit={adUnits.top}
          size={[[970, 50], [300, 250]]}
          sizeMapping={sizeMapping}
          divId="div-gpt-ad-top"
        />
      </div>

      {/* ✅ FILE CONTENT */}
      {article.file ? (
        <div className="prose max-w-none text-gray-700">
          {content.split("\n").map((line, idx) =>
            line.trim() ? (
              <p key={idx}>{line}</p>
            ) : (
              <br key={idx} />
            )
          )}
        </div>
      ) : (
        <div className="border-t border-gray-200 pt-5 space-y-6">

          {[...Array(10)].map((_, index) => {
            const subtopicKey = `subtopic${index + 1}`;
            const descriptionKey = `description${index + 1}`;

            if (article[subtopicKey] || article[descriptionKey]) {
              return (
                <React.Fragment key={index}>

                  {/* 📄 CONTENT */}
                  <div>
                    {article[subtopicKey] && (
                      <h2 className="text-lg font-semibold text-indigo-600">
                        {article[subtopicKey]}
                      </h2>
                    )}

                    {article[descriptionKey] && (
                      <p className="text-gray-600 mt-2">
                        {article[descriptionKey]}
                      </p>
                    )}
                  </div>

                  {/* 🔥 INLINE ADS */}
                  {(index + 1) % 2 === 0 && (
                    <div className="my-6 flex justify-center min-h-[100px]">
                      <AdManagerAd
                        adUnit={
                          index % 4 === 0
                            ? adUnits.inline
                            : adUnits.inlineAlt
                        }
                        size={[
                          [970, 50],
                          [300, 250],
                        ]}
                        sizeMapping={sizeMapping}
                        divId={`div-gpt-ad-inline-${index}`}
                      />
                    </div>
                  )}

                </React.Fragment>
              );
            }

            return null;
          })}

        </div>
      )}

      {/* 📌 STICKY FOOTER AD */}
      {showSticky && (
        <div className="fixed bottom-0 left-0 w-full flex justify-center z-50 bg-white shadow-md border-t">

          {/* ❌ Close Button */}
          <button
            onClick={() => setShowSticky(false)}
            className="absolute right-3 top-1 text-black text-lg"
          >
            ✕
          </button>

          <AdManagerAd
            adUnit={adUnits.sticky}
            size={[[970, 50], [300, 250]]}
            sizeMapping={sizeMapping}
            divId="div-gpt-ad-sticky"
          />

        </div>
      )}

    </div>
  );
};

export default ArticleDetail;




// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import articles from "./ArticlesBulk";
// import AdManagerAd from "../JobDetails/AdsenseAd";

// const ArticleDetail = () => {
//   const { id } = useParams();
//   const article = articles.find((a) => a.id === parseInt(id));
//   const [content, setContent] = useState("");

//   // ✅ Responsive size mapping
//   const sizeMapping = [
//     { viewport: [1024, 0], sizes: [[970, 90], [728, 90]] },
//     { viewport: [768, 0], sizes: [[468, 60]] },
//     { viewport: [0, 0], sizes: [[300, 250], [320, 50]] },
//   ];

//   // ✅ Fetch content
//   useEffect(() => {
//     if (!article?.file) return;

//     fetch(article.file)
//       .then((res) => res.text())
//       .then((data) => setContent(data));
//   }, [article?.file]);

//   if (!article)
//     return <p className="text-center mt-10">Article not found.</p>;

//   return (
//     <div className="max-w-4xl mx-auto py-10 px-5 pb-24">
//       {/* ✅ Title */}
//       <h1 className="text-3xl font-bold mb-5">{article.title}</h1>
//       <p className="text-gray-700 mb-5">{article.description}</p>

//       {/* ✅ File Content */}
//       {article.file ? (
//         <div className="prose max-w-none text-gray-700">
//           {content.split("\n").map((line, idx) =>
//             line.trim() ? <p key={idx}>{line}</p> : <br key={idx} />
//           )}
//         </div>
//       ) : (
//         <div className="border-t border-gray-200 pt-5 space-y-6">
//           {[...Array(10)].map((_, index) => {
//             const subtopicKey = `subtopic${index + 1}`;
//              <div className="my-6 flex justify-center w-full overflow-hidden min-h-[100px]">
//                       <AdManagerAd
//                         adUnit="/23318400632/Display/inline"
//                         size={[
//                           [970, 90],
//                           [728, 90],
//                           [468, 60],
//                           [300, 250],
//                           [320, 50],
//                         ]}
//                         sizeMapping={sizeMapping}
//                         divId={`div-gpt-ad-inline-${index}`}
//                       />
//                     </div>
//             const descriptionKey = `description${index + 1}`;

//             if (article[subtopicKey] || article[descriptionKey]) {
//               return (
//                 <div key={index}>
//                   {article[subtopicKey] && (
//                     <h2 className="text-lg font-medium text-indigo-600">
//                       {article[subtopicKey]}
//                     </h2>
//                   )}
//                   <div className="my-6 flex justify-center w-full overflow-hidden min-h-[100px]">
//                     <AdManagerAd
//                       adUnit="/23318400632/Display/inline"
//                       size={[
//                         [970, 90],
//                         [728, 90],
//                         [468, 60],
//                         [300, 250],
//                         [320, 50],
//                       ]}
//                       sizeMapping={sizeMapping}
//                       divId={`div-gpt-ad-inline-${index}`}
//                     />
//                   </div>
//                   {article[descriptionKey] && (
//                     <p className="text-gray-600 mt-1">
//                       {article[descriptionKey]}
//                     </p>
//                   )}


//                   <div className="my-6 flex justify-center w-full overflow-hidden min-h-[100px]">
//                     <AdManagerAd
//                       adUnit="/23318400632/Display/inline"
//                       size={[
//                         [970, 90],
//                         [728, 90],
//                         [468, 60],
//                         [300, 250],
//                         [320, 50],
//                       ]}
//                       sizeMapping={sizeMapping}
//                       divId={`div-gpt-ad-inline-${index}`}
//                     />
//                   </div>

//                 </div>
//               );
//             }
//             return null;
//           })}
//         </div>
//       )}

//       {/* ✅ Sticky Bottom Ad (sticky2)
//       <div className="fixed bottom-0 left-0 w-full flex justify-center z-50 bg-white shadow-md">
//         <AdManagerAd
//           adUnit="/23318400632/Display/sticky2"
//           size={[[728, 90], [320, 50], [300, 50]]}
//           sizeMapping={sizeMapping}
//           divId="div-gpt-ad-sticky2-detail"
//         />
//       </div> */}
//     </div>
//   );
// };

// export default ArticleDetail;

// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import articles from "./ArticlesBulk";
// import AdSenseAd from "../JobDetails/AdsenseAd";

// const ArticleDetail = () => {
//   const { id } = useParams();
//   const article = articles.find((a) => a.id === parseInt(id));
//   const [content, setContent] = useState("");

//   // Array of AdSense slots for each subtopic
//   const adSlots = [
//     "2033357033", // subtopic 1
//     // "1933833423", // subtopic 2
//     "7612986772", // subtopic 3
//     "2166103457", // subtopic 4
//     "5397925931", // subtopic 5
//     "5948590274", // subtopic 6
//     // subtopic 10
//   ];

//   useEffect(() => {
//     if (article?.file) {
//       fetch(article.file)
//         .then((res) => res.text())
//         .then((data) => setContent(data));
//     }
//   }, [article]);

//   if (!article) return <p className="text-center mt-10">Article not found.</p>;

//   return (
//     <div className="max-w-4xl mx-auto py-10 px-5">
//       <h1 className="text-3xl font-bold mb-5">{article.title}</h1>
//       <p className="text-gray-700 mb-5">{article.description}</p>

//       <AdSenseAd
//         client="ca-pub-2161842895850825"
//         slot={adSlots[index] || "5948590274"} // fallback slot
//         format="auto"
//         responsive="true"
//       />


//       {article.file ? (
//         <div className="prose max-w-none text-gray-700">
//           {content.split("\n").map((line, idx) =>
//             line.trim() ? <p key={idx}>{line}</p> : <br key={idx} />
//           )}
//         </div>
//       ) : (
//         <div className="border-t border-gray-200 pt-5 space-y-6">
//           {[...Array(10)].map((_, index) => {
//             const subtopicKey = `subtopic${index + 1}`;
//             const descriptionKey = `description${index + 1}`;
//             if (article[subtopicKey] || article[descriptionKey]) {
//               return (
//                 <div key={index}>
//                   {article[subtopicKey] && (
//                     <h2 className="text-lg font-medium text-indigo-600">
//                       {article[subtopicKey]}
//                     </h2>
//                   )}
//                   {article[descriptionKey] && (
//                     <p className="text-gray-600 mt-1">
//                       {article[descriptionKey]}
//                     </p>
//                   )}
//                   {/* AdSense Ad after each subtopic with dynamic slot */}
//                   <div className="my-4">
//                     <AdSenseAd
//                       client="ca-pub-2161842895850825"
//                       slot={adSlots[index] || "2033357033"} // fallback slot
//                       format="auto"
//                       responsive="true"
//                     />
//                   </div>
//                 </div>
//               );
//             } else return null;
//           })}

//           {article.iframeUrl && (
//             <div className="mb-6">
//               <iframe
//                 src={article.iframeUrl}
//                 width="100%"
//                 height="400"
//                 title="Article Video"
//                 frameBorder="0"
//                 allowFullScreen

//               />
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ArticleDetail;


